import { detect } from "detect-browser";
import { useRef } from "react";

const useBrowser = () => {
  const browserRef = useRef(detect());
  return browserRef.current;
};

export default useBrowser;
